import { FeedbackStatusLevel } from '../../../../../pure-js/enums/FeedbackLevel'
import { INTERAX_COLORS } from '../../../constants/colors'

/** Status dot / label colors — aligned with feedback UI accent palette */
export function getProfileIndicatorStatusColor(level: FeedbackStatusLevel): string {
  switch (level) {
    case FeedbackStatusLevel.EXCELLENT:
      return INTERAX_COLORS.green
    case FeedbackStatusLevel.GOOD:
      return INTERAX_COLORS.blue
    case FeedbackStatusLevel.NEEDS_WORK:
      return INTERAX_COLORS.sun
    default:
      return INTERAX_COLORS.blue
  }
}

export function getProfileIndicatorGradient(level: FeedbackStatusLevel): string {
  const color = getProfileIndicatorStatusColor(level)
  return `linear-gradient(360deg, ${color} 0%, ${color} 23.08%, ${INTERAX_COLORS.white} 100%)`
}

export function getProfileIndicatorGlow(level: FeedbackStatusLevel): string {
  const color = getProfileIndicatorStatusColor(level)
  return `0px 0px 10px rgba(0, 0, 0, 0.5), 0px 0px 20px ${color}40`
}
